export const VENMO_MAX_AMOUNT = 2500;

export const REVOCATION_MINUTE_OPTIONS = [
	{ value: 0, label: 'No cancellation window' },
	{ value: 5, label: '5 minutes' },
	{ value: 15, label: '15 minutes (recommended)' },
	{ value: 30, label: '30 minutes' },
	{ value: 60, label: '60 minutes (maximum)' },
];

export const REMINDER_INTERVAL_OPTIONS = [
	{ value: 0, label: 'Off' },
	{ value: 1, label: 'Every day' },
	{ value: 2, label: 'Every 2 days' },
	{ value: 3, label: 'Every 3 days' },
	{ value: 5, label: 'Every 5 days' },
	{ value: 7, label: 'Every 7 days' },
];

export const SUBSCRIPTION_STATUS_LABELS = {
	trialing: 'Trialing',
	trial_expired: 'Trial ended',
	active: 'Active',
	past_due: 'Past due',
	canceled: 'Canceled',
	none: 'No subscription',
};

export const SUBSCRIPTION_STATUS_COLORS = {
	trialing: 'info',
	trial_expired: 'warning',
	active: 'success',
	past_due: 'warning',
	canceled: 'default',
	none: 'default',
};

export const SETTINGS_SECTIONS = {
	company: 'company',
	proposals: 'proposals',
	payments: 'payments',
	workflow: 'workflow',
	time: 'time',
	sms: 'sms',
	billing: 'billing',
};

export const FOUNDER_BILLING_CONTACT = {
	name: 'Evan Cortez',
	email: 'management@bidzbase.com',
};

export const formatBillingDate = (isoDate) => {
	if (!isoDate) {
		return null;
	}
	const date = new Date(isoDate);
	if (Number.isNaN(date.getTime())) {
		return null;
	}
	return date.toLocaleDateString(undefined, {
		month: 'long',
		day: 'numeric',
		year: 'numeric',
	});
};
